import { ReactNode, useEffect, useReducer, useRef } from "react";

import { registerMemoryStatsProvider } from "utils/memoryDiagnostics";

import { DispatchContext, initialState, LazyStateContext, reducer, StateContext } from "./reducer";

export function HighlightCollectionsProvider({ children }: { children: ReactNode }) {
    const [state, dispatch] = useReducer(reducer, initialState);
    const lazyValue = useRef(state);
    lazyValue.current = state;

    useEffect(() => {
        return registerMemoryStatsProvider("highlightCollectionsState", () => {
            let totalIdCount = 0;
            let totalResidentBytes = 0;
            const collections: Record<string, number> = {};
            for (const [key, { ids }] of Object.entries(lazyValue.current)) {
                totalIdCount += ids.size;
                // ids and idArr share one sorted Uint32Array (4 bytes/id).
                totalResidentBytes += ids.sortedIds.byteLength;
                if (ids.size > 0) {
                    collections[key] = ids.size;
                }
            }
            return { idCount: totalIdCount, residentBytes: totalResidentBytes, collections };
        });
    }, []);

    return (
        <StateContext.Provider value={state}>
            <LazyStateContext.Provider value={lazyValue}>
                <DispatchContext.Provider value={dispatch}>{children}</DispatchContext.Provider>
            </LazyStateContext.Provider>
        </StateContext.Provider>
    );
}
